import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getTag } from 'selectors';

class DNACategory extends PureComponent {
  getCategoryClassName = () => {
    const { category, topCategories, isActive } = this.props;
    const isInTop = topCategories.find(cat => cat.tag.id === category.id);
    let className = `DNADatum-category ${category.displayClass}`;
    if (isInTop || isActive) {
      return className;
    } else {
      return `${className} remainder`;
    }
  };

  render() {
    const { category } = this.props;
    return (
      <div data-id={category.id} className={this.getCategoryClassName()} />
    );
  }
}

DNACategory.propTypes = {
  isActive: PropTypes.bool.isRequired,
  category: PropTypes.object.isRequired,
  tagInfo: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

function mapStateToProps(state, props) {
  const category = getTag(state, props.tagInfo);
  return {
    topCategories: state.entities.summaries.topTags.categories,
    category,
  };
}

export default connect(mapStateToProps)(DNACategory);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/DNAGraph/DNACategory.js